module.exports = __webpack_public_path__ + "img/kr-product-ecomm-card3-bg.baa28d8.png";